<template>
  <div>
    <b-card title="Search by ID" class="b-card-space">
      <p class="text-danger" v-if="cannotFind">
        {{ errorMessage }}
      </p>
      <b-row>
        <b-col xl="2" lg="2">
          Assignment Term ID:
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="2" lg="2">
          <b-form-input type="number"
                        min="0"
                        v-model.number="assignmentTermId">
          </b-form-input>
        </b-col>
        <b-col xl="2" lg="2">
          <b-btn variant="success"
                 :disabled="!assignmentTermIdSet()"
                 @click="findAssignmentTermById()">
            Search
          </b-btn>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import AssignmentTermsProvider from '@/services/AssignmentTermsProvider'

export default {
  name: 'SearchById',
  data () {
    return {
      assignmentTermId: null,
      cannotFind: false,
      errorMessage: 'Cannot find Assignment Term with this ID.'
    }
  },
  methods: {
    assignmentTermIdSet () {
      if (this.assignmentTermId) {
        return true
      } else {
        return false
      }
    },
    goToAssignmentTerms (body) {
      this.$router.push({
        name: 'AssignmentTermsList',
        params: {
          vendorId: +body.vendor_id,
          productId: +body.product_id,
          assignmentTermId: body.assignment_terms[0].id
        }
      })
    },
    findAssignmentTermById () {
      if (this.assignmentTermId) {
        AssignmentTermsProvider.all(
          { assignmentTermId: this.assignmentTermId })
          .then((resp) => {
            if (resp.body.assignment_terms[0] !== undefined) {
              this.goToAssignmentTerms(resp.body)
            } else {
              this.cannotFind = true
            }
          })
      }
    }
  }
}
</script>
